export const STANDARD_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
